import {
  Div, FixedLayout, Group,
  MiniInfoCell, Panel, SimpleCell,
  SubnavigationBar, SubnavigationButton, Title,
} from '@vkontakte/vkui';
import { Panels } from '../Consts';
import { PlatformPanelHeader } from '../components/PlatformPanelHeader';
import { useAppContext } from '../../AppContext';
import React, { useEffect, useState } from 'react';
import { UserAvatar } from '../components/UserAvatar';
import { ImgsGallery } from '../components/ImgsGalleryComponent';
import { getRouteCreatePayment, getRouteCreatePaymentFromQrCode, getRouteCreatePaymentsFromQrCode } from '../../route';

const CURRENT_PANEL = Panels.SCAN_RECEIPT_PANEL;
const ScanReceiptPanel = () => {
  const context = useAppContext();
  const params = context.router.getParams();

  const [item, setItem] = useState(null);
  const [isLoad, setIsLoad] = useState(false);

  const fetch = () => {
    context.httpClient()
      .getReceiptInfo(params.eventId, params.id)
      .then((response) => {
        setItem(response.data);
        setIsLoad(false);
      })
      .catch((error) => {
        context.showError(error);
      })
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    context.spinner(isLoad);
  }, [isLoad])
  useEffect(() => {
    setIsLoad(true);
    context.init()
      .then(() => {
        fetch();
      })
      .catch((e) => {
        context.showError(e);
      });
  }, []);

  if (item === null) {
    return (<Panel id={CURRENT_PANEL}></Panel>);
  }

  return (<Panel nav={CURRENT_PANEL}>
    <PlatformPanelHeader
      text={context.lang().getKey(CURRENT_PANEL, 'header')}
    />
    <Group>
      <SimpleCell
        disabled={true}
        key={item.creator.id}
        before={<UserAvatar type={item.creator.type} src={item.creator.img} name={item.creator.name} id={item.creator.id} />}
        after={context.lang().dateFormatLong(new Date(item.date))}
      >
        {item.creator.name}
      </SimpleCell>

    </Group>

    <MiniInfoCell
      mode="accent"
      before={context.lang().getKey(CURRENT_PANEL, 'row_title__status')}
    >
      {context.lang().getKey(CURRENT_PANEL, 'status_label__' + item.status)}
    </MiniInfoCell>
    {
      item.totalAmount > 0.001 && (<MiniInfoCell
        mode="accent"
        before={context.lang().getKey(CURRENT_PANEL, 'row_title__total_amount')}
      >
        {item.totalAmount}
      </MiniInfoCell>)
    }
    {
      item.totalCountItems > 0.0001 && (<MiniInfoCell
        mode="accent"
        before={context.lang().getKey(CURRENT_PANEL, 'row_title__total_count_items')}
      >
        {item.totalCountItems}
      </MiniInfoCell>)
    }

    <Group>
      {
        item.status === 'finish' && (<SimpleCell>
          <Title level="2">{context.lang().getKey(CURRENT_PANEL, 'row_title__items')}</Title>
        </SimpleCell>)
      }
      {
        item.items.map((data, index) => (<SimpleCell
          expandable="auto"
          key={index}
          subhead={data.name}
          after={context.lang().formatPrice(data.total_amount)}
          onClick={() => context.router.push(...getRouteCreatePayment(params.eventId, null, {
            name: data.name,
            comment: context.lang().formatPrice(data.amount) + ' x ' + data.quantity,
            price: parseFloat(data.total_amount).toFixed(2),
            date: item.date,
            receiptId: item.id,
          }))}
        >
          {context.lang().formatPrice(data.amount)} x {data.quantity}
        </SimpleCell>))
      }
    </Group>

    <Div>
      <ImgsGallery images={[
        {
          id: 0,
          src: item.img,
          name: '',
        }
      ]} />
    </Div>

    {
      item.status === 'finish' && (<FixedLayout
        filled={true}
        vertical="bottom"
        style={{ textAlign: 'center' }}
      >
        <SubnavigationBar
          mode="fixed"
        >
          <SubnavigationButton
            size="m"
            textLevel={'1'}
            selected={true}
            onClick={() => context.router.push(...getRouteCreatePaymentsFromQrCode(params.eventId, item.items || [], item.date))}
          >
            {context.lang().getKey(CURRENT_PANEL, 'button_action__by_positions_label')}
          </SubnavigationButton>
          <SubnavigationButton
            size="m"
            textLevel={'1'}
            selected={true}
            onClick={() => context.router.push(...getRouteCreatePaymentFromQrCode(params.eventId, '', item.items || [], item.date))}
          >
            {context.lang().getKey(CURRENT_PANEL, 'button_action__one_sum_label')}
          </SubnavigationButton>
        </SubnavigationBar>
      </FixedLayout>)
    }
  </Panel>)
}

export default ScanReceiptPanel;